import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { commissionEarningModelOptions } from '../schemas/commission-earning-model-schema';

export function CommissionEarningModelInput({ isEditable, className }: { isEditable?: boolean; className?: string }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="commission_earning_model"
      render={({ field: { value, onChange } }) => (
        <FormSelect
          disabled={!isEditable}
          value={value}
          getOptionLabel={(option) => option.name}
          onChange={onChange}
          options={commissionEarningModelOptions()}
          label="Commission Earning Model"
          formItemClassName={className}
        />
      )}
    />
  );
}
